import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AlertCircleFill, ArrowIosForward, Lock2 } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Stack, StatusPill, Tooltip, Typography } from '@lyearn/ui';

import { ItemProps } from '../../types';

const Item: React.FC<ItemProps> = ({
  className,
  title,
  icon,
  onClick,
  isRecommended,
  error,
  disabled,
  disabledReason,
}) => {
  const { t } = useTranslation('Tags');

  const itemContent = (
    <Stack
      alignItems="center"
      className={cn(
        'cursor-pointer rounded py-12 px-12 hover:bg-bg-hover active:bg-interactive-secondary',
        disabled && 'opacity-50 cursor-not-allowed pointer-events-none',
        className,
      )}
      direction="row"
      justifyContent="between"
      onClick={disabled ? undefined : onClick}>
      <Stack alignItems="center" direction="row">
        <Box className="me-12">{icon}</Box>
        <Typography color={error ? 'text-text-error' : undefined} variant="body-short-02">
          {title}
        </Typography>
        {error ? (
          <Tooltip placement="right" title={error}>
            <Stack className="ms-8">
              <AlertCircleFill className="h-16 w-16" fillColorToken="icon-error" />
            </Stack>
          </Tooltip>
        ) : null}
      </Stack>
      {isRecommended ? (
        <Box className="ms-auto">
          <StatusPill
            appearance="primary"
            className="mx-12 me-4"
            label={t('Course:Form.Suggested')}
            size="medium"
            variant="light"
          />
        </Box>
      ) : null}
      {disabled ? (
        <Lock2 className="ms-auto me-4" fillColorToken="icon-secondary" height={15} width={15} />
      ) : (
        <ArrowIosForward className="h-18 w-18 fill-current text-icon-secondary rtl:rotate-180" />
      )}
    </Stack>
  );

  if (disabled && disabledReason) {
    return (
      <Tooltip placement="top" title={disabledReason}>
        <Box>{itemContent}</Box>
      </Tooltip>
    );
  }

  return itemContent;
};

export default React.memo(Item);
